import * as React from 'react';
import { ChevronDown } from 'lucide-react';
import { cn } from './lib/utils';

/**
 * Styled native <select> for filter dropdowns.
 * Consistent height (h-8), border, focus ring, chevron indicator.
 *
 * <FilterSelect value={status} onChange={setStatus} label="Status">
 *   <option value="all">All</option>
 *   <option value="active">Active</option>
 * </FilterSelect>
 *
 * label — screen-reader label (rendered visually only when showLabel is true)
 */

function FilterSelect({ value, onChange, label, showLabel = false, children, className, ...props }) {
  return (
    <div className={cn('relative inline-flex items-center', className)}>
      {showLabel && label && (
        <span className="mr-1.5 text-caption text-text-muted whitespace-nowrap">{label}:</span>
      )}
      <div className="relative">
        <select
          value={value}
          onChange={e => onChange(e.target.value)}
          aria-label={label}
          className={cn(
            'h-8 appearance-none rounded-lg border border-nn-border bg-nn-white',
            'pl-3 pr-7 text-body text-text-dark',
            'focus:outline-none focus:ring-2 focus:ring-aqua/40 focus:border-aqua',
            'transition-colors cursor-pointer'
          )}
          {...props}
        >
          {children}
        </select>
        <ChevronDown className="pointer-events-none absolute right-2 top-1/2 -translate-y-1/2 h-3.5 w-3.5 text-text-muted" />
      </div>
    </div>
  );
}

export { FilterSelect };
